/**
 * Internal: only ProjectStateAdapterBridge and shared-view-project-adapter may import from this file.
 * Exposes the single way to update the adapter; no other code should call setProjectSnapshot.
 */

import type { ProjectSnapshot } from '../project-state-adapter';
import { projectStateAdapter } from './project-state-adapter.shared';

export function setProjectSnapshot(next: ProjectSnapshot): void {
  projectStateAdapter._setSnapshot(next);
}
